module.exports = __webpack_public_path__ + "main/images/shared/google-play-lock-up.520ced7823b4d011518dde6117c9194e.svg";